import { ReactElement } from 'react'
import cn from 'classnames'
import s from './Toast.module.scss'
import Alert from '@components/icons/Alert'
type ToastProps = {
    isOpen?: boolean
    text: string
    sticked?: boolean
}

const Toast = ({ isOpen, text, sticked }: ToastProps): ReactElement => {
    return (
        <div
            className={cn(s['container'], {
                [s['container-opened']]: isOpen,
                [s['container-sticked']]: sticked
            })}
        >
            <div className={cn(s['content'])}>
                <div className={cn(s['content-inner'])}>
                    <div className={cn(s['icon'])}>
                        <Alert />
                    </div>
                    <div className={cn(s['text'])}>{text}</div>
                </div>
            </div>
        </div>
    )
}
export default Toast
